import { CardButton, ColorDynamic } from '@superdispatch/ui';
import styled, { css } from 'styled-components';

export const UploadDispatchSheetCardButton = styled(CardButton)<{
  $isDragActive: boolean;
  $isDragReject: boolean;
}>`
  ${({ $isDragActive, $isDragReject }) =>
    $isDragActive &&
    css`
      background-color: ${ColorDynamic.White50};
      border: 4px dashed
        ${$isDragReject ? ColorDynamic.Yellow300 : ColorDynamic.Blue300};
    `}
`;
